export const tabelaNaturezaReceita: Record<string, string> = {
  '4.3.10':
    'Produtos sujeitos a alíquotas diferenciadas - incidência monofásica (CST 02 e 04)',
  '4.3.11':
    'Produtos sujeitos a alíquotas por unidade de medida de produto - incidência monofásica (CST 03 e 04)',
  '4.3.12': 'Produtos sujeitos à substituição tributária (CST 05)',
  '4.3.13': 'Produtos sujeitos à alíquota zero (CST 06)',
  '4.3.14': 'Operações com isenção (CST 07)',
  '4.3.15': 'Operações sem incidência (CST 08)',
  '4.3.16': 'Operações com suspensão (CST 09)',
  '4.3.17':
    'Outros produtos e operações sujeitos a alíquotas diferenciadas (CST 02 e CST de créditos)',
};
